"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
/**
 * The message as it will actually send: the whole email, rendered by the same `email_preview`
 * endpoint the design surface uses, in the captured Mailchimp chrome.
 *
 * It has to be a server render rather than a client-side approximation of the form state. The server
 * REWRITES what the editor typed — MarketingHtml strips fonts and colours, unwraps pasted
 * <div>/<table> chrome, and reapplies the email's own Georgia/indigo styles. A preview built from the
 * form fields would show the editor their Comic Sans and the inbox would show Georgia, which is worse
 * than no preview at all.
 */
function LedMarketingPreview(_a) {
    var src = _a.src, isLoading = _a.isLoading, error = _a.error;
    var frame = (0, react_1.useRef)(null);
    /**
     * The email is ~3000px tall and the marketing section sits near the bottom, after the quote, the
     * video and the Challenge — so the iframe opens on the masthead unless we move it. The server
     * marks the section with `data-led-preview` for previews only (never for the feeds).
     *
     * `sandbox="allow-same-origin"` WITHOUT `allow-scripts` is deliberate: the email needs no
     * JavaScript, so staff-authored content stays inert, while the parent can still reach
     * contentDocument to do this scroll.
     */
    var scrollToMessage = function () {
        var _a, _b;
        var doc = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentDocument;
        (_b = doc === null || doc === void 0 ? void 0 : doc.querySelector('[data-led-preview]')) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ block: 'start' });
    };
    return (react_1.default.createElement(Paper_1.default, { elevation: 0, variant: "outlined", sx: { p: 3, mt: 3 } },
        react_1.default.createElement(Stack_1.default, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 2 } },
            react_1.default.createElement(Typography_1.default, { variant: "h6" }, "Message preview"),
            react_1.default.createElement(Chip_1.default, { size: "small", label: "sample", variant: "outlined" })),
        react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { mb: 2, color: 'text.secondary' } },
            "The whole email, as it will send. The quote, video and Challenge shown are",
            ' ',
            react_1.default.createElement("em", null, "today's"),
            " \u2014 only the message is yours."),
        error && react_1.default.createElement(Alert_1.default, { severity: "warning", sx: { mb: 2 } }, error),
        isLoading && react_1.default.createElement(Skeleton_1.default, { variant: "rectangular", height: 560 }),
        !isLoading && src && (react_1.default.createElement(Box_1.default, { component: "iframe", ref: frame, src: src, title: "Email preview", sandbox: "allow-same-origin", onLoad: scrollToMessage, sx: { width: '100%', height: 560, border: '1px solid #ddd', borderRadius: 1, bgcolor: '#fff' } })),
        !isLoading && !src && !error && (react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { color: 'text.secondary' } }, "Save the message to preview it. Saving does not publish: a message only sends once it is enabled and inside its date range."))));
}
exports.default = LedMarketingPreview;
